import {
  RESET_FEATURES,
  RESET_FEATURE,
  RESET_ERROR,
  GET_FEATURES,
  SET_FEATURES,
  API_ERROR,
  GET_FEATURE,
  SET_FEATURE,
  CREATE_FEATURE,
  CREATE_FEATURE_SUCCESS,
  EDIT_FEATURE,
  EDIT_FEATURE_SUCCESS,
  DELETE_FEATURE,
  DELETE_FEATURE_SUCCESS,
} from "./actionTypes";

export const resetFeatures = () => {
  return {
    type: RESET_FEATURES,
    payload: {},
  };
};

export const resetFeature = () => {
  return {
    type: RESET_FEATURE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getFeatures = (page, qnt, name, isForm) => {
  return {
    type: GET_FEATURES,
    payload: { page, qnt, name, isForm },
  };
};

export const setFeatures = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_FEATURES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createFeature = (newFeatureValues) => {
  return {
    type: CREATE_FEATURE,
    payload: { newFeatureValues },
  };
};
export const createFeatureSuccess = (message) => {
  return {
    type: CREATE_FEATURE_SUCCESS,
    payload: { message },
  };
};

export const getFeature = (idFeature, isForm) => {
  return {
    type: GET_FEATURE,
    payload: { idFeature, isForm },
  };
};
export const setFeature = (data) => {
  return {
    type: SET_FEATURE,
    payload: { data },
  };
};

export const editFeature = (idFeature, newFeatureValues) => {
  return {
    type: EDIT_FEATURE,
    payload: { idFeature, newFeatureValues },
  };
};
export const editFeatureSuccess = (message) => {
  return {
    type: EDIT_FEATURE_SUCCESS,
    payload: { message },
  };
};

export const deleteFeature = (idFeature) => {
  return {
    type: DELETE_FEATURE,
    payload: { idFeature },
  };
};
export const deleteFeatureSuccess = (message) => {
  return {
    type: DELETE_FEATURE_SUCCESS,
    payload: { message },
  };
};
